import React from "react";

import infoImg1 from "../../assets/images/contact/2.png";
import infoImg2 from "../../assets/images/contact/3.png";
import infoImg3 from "../../assets/images/contact/4.png";
import { IAS_PEDAGOGY } from "../../app-constants";

const ContactInfo = (props) => {
  const { contactBoxClass } = props;
  return (
    <ul className="address-sec">
      <li>
        <em className="icon">
          <img src={infoImg1} alt="image" />
        </em>
        <span className="text">
          <em>Address</em> {IAS_PEDAGOGY.ADDRESS}
        </span>
      </li>
      <li>
        <em className="icon">
          <img src={infoImg2} alt="image" />
        </em>
        <span className="text">
          <em>Contact</em>{" "}
          <a href={`tel:${IAS_PEDAGOGY.OFFICE_PHONE}`}>
            {IAS_PEDAGOGY.OFFICE_PHONE}{" "}
          </a>
          <a href={`tel:${IAS_PEDAGOGY.PHONE_CONTACT2}`}>
            {IAS_PEDAGOGY.PHONE_CONTACT2}{" "}
          </a>
          <br />
          <a href={`mailto:${IAS_PEDAGOGY.CONTACT_EMAIL}`}>
            {IAS_PEDAGOGY.CONTACT_EMAIL}
          </a>
        </span>
      </li>
      <li>
        <em className="icon">
          <img src={infoImg3} alt="image" />
        </em>
        <span className="text">
          <em>Hour of operation</em> Monday - Friday: 08:00 - 20:00 <br />
          Saturday & Sunday: 07:30 - 20:00
        </span>
      </li>
    </ul>
  );
};

export default ContactInfo;
